import { render, staticRenderFns } from "./system_role_list.vue?vue&type=template&id=78dcb10b&scoped=true"
import script from "./system_role_list.vue?vue&type=script&lang=js"
export * from "./system_role_list.vue?vue&type=script&lang=js"
import style0 from "./system_role_list.vue?vue&type=style&index=0&id=78dcb10b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dcb10b",
  null
  
)

export default component.exports